<template>
  <div>
    <!-- <Fo
    <hr class="m-t-sm m-b-sm" />
    <div class="pd-l-5 pd-r-5">
      <Button
        @click="$emit('on-seach', srch)"
        icon="md-refresh"
        long
        type="primary"
        >Ачааллах</Button
      >
    </div> -->
  </div>
</template>

<script>
var _ = require("lodash");

import "element-ui/lib/theme-chalk/index.css";
import {
  Form,
  //Input,
  FormItem,
  DatePicker,
  Button
  //Notification
  //Checkbox,
  //RadioGroup,
  //Radio
} from "element-ui";

export default {
  components: {
    Form,
    //Input,
    FormItem,
    DatePicker,

    Button
  },
  data() {
    return {
      srch: {
        tid: this.$store.state.app.mainReportData.propObj.tid,
        userId: this.$store.state.app.mainReportData.propObj.userId
      },
      coreSearchModel: {},
      filterData: {
        tasks: []
      }
    };
  },
  methods: {},
  mounted() {
    this.$emit('on-seach', this.srch);
  }
};
</script>
